import React, { useState, useEffect } from "react";
import video1 from "../../assests/video1.mp4";
import video2 from "../../assests/video02.mp4";
import video3 from "../../assests/video03.mp4";
import prelorder from "../../assests/loadingIcon.png";
import Logo from "../../assests/mediLogo.png";
import { NavLink, Link } from "react-router-dom";
import { GrLinkPrevious, GrLinkNext } from "react-icons/gr";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import axios from "axios";
import { baseImg } from "../Api/ImageUrl";
import { baseUrl } from "../Api/BaseUrl";
import image1 from "../../assests/partners/Coca-Cola.png";
import image2 from "../../assests/partners/um.png";
import image3 from "../../assests/partners/Arena-Media.png";
import img4 from "../../assests/partners/Emirates.png";
import img5 from "../../assests/partners/Ooredoo.png";
import img6 from "../../assests/partners/LG-Logo.png";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGooglePlusG,
  FaYoutube,
} from "react-icons/fa";
// Localization data
const headerTranslations = {
  1: {
    news: "News",
    agency: "Agency",
    services: "Services",
    work: "Work",
    team: "Team",
    contact: "Contact Us",
    partnerstext: "AGENSY PROUD IS QUALITY OF PARTNERS",
    ourservices: "Our Services",
    email: "Email",
    address: "Address",
  },
  2: {
    news: "Nouvelles",
    agency: "Agence",
    services: "Services",
    work: "Travail",
    team: "Équipe",
    contact: "Contactez",
    partnerstext: "AGENSY FIER EST LA QUALITÉ DES PARTENAIRES",
    ourservices: "Nos prestations",
    email: "e-mail",
    address: "Adresse",
  },
  3: {
    news: "الأخبار",
    agency: "وكالة",
    services: "الخدمات",
    work: "العمل",
    team: "الفريق",
    contact: "اتصل بنا",
    partnerstext: "تفتخر الوكالة بجودة الشركاء",
    ourservices: "خدماتنا",
    email: "بريد إلكتروني",
    address: "عنوان",
  },
};

const Home = () => {
  const [isOverflow, setIsOverflow] = useState(false);
  const [Active, setActive] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [language, setLanguage] = useState(1);
  const [introData, setIntroData] = useState(null);
  const [data, setData] = useState("");
  const [uniqueMedia, setUniqueMedia] = useState("");
  const [uniqueNews, setUniqueNews] = useState("");
  const [joinUsData, setJoinUsData] = useState(null);
  const [footerData, setFooterData] = useState(null);
  // document.body.dir = i18n.dir();

  useEffect(() => {
    const fetchJoinUs = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_cms_home_section`, {
          language: language,
        });
        setIntroData(response.data.details);
      } catch (error) {
        console.log("Error Fetching the Join Us Data:", error);
      }
    };

    const fetchOurWork = async () => {
      try {
        const response = await axios.post(
          `${baseUrl}get_cms_our_work_section`,
          {
            language: language,
          }
        );
        setData(response.data.details);
      } catch (error) {
        console.log("Error While Fetching data From Our Work:", error);
      }
    };

    const fetchMedia = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_cms_home_section`, {
          language: language,
        });
        setUniqueMedia(response.data.details);
      } catch (error) {
        console.log("Error fetching the Media Data", error);
      }
    };

    const fetchNews = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_cms_news_section`, {
          language: language,
        });
        setUniqueNews(response.data.Details);
      } catch (error) {
        console.log("Error fetching the Media Data", error);
      }
    };

    const fetchJoincontent = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_cms_home_section`, {
          language: language,
        });
        setJoinUsData(response.data.details);
      } catch (error) {
        console.log("Error Fetching the Join Us Data:", error);
      }
    };

    const fetchFooter = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_footer_section`, {
          language: language,
        });
        setFooterData(response.data.Details);
      } catch (error) {
        console.error("Error fetching the Footer Data:", error);
      }
    };

    fetchFooter();
    fetchJoinUs();
    fetchOurWork();
    fetchMedia();
    fetchNews();
    fetchJoincontent();
  }, [language]);

  // ToogleControl Method
  const handleToggleClick = () => {
    if (Active) {
      setIsOverflow(!isOverflow);
      setActive(false);
      // Adding transition delays when removing 'active'
      setTimeout(() => {
        document.querySelector(".all-cases").style.transitionDelay = "0.5s";
        document.querySelector(".all-cases .layer").style.transitionDelay =
          "0.3s";
        document.querySelector(".all-cases .inner").style.transitionDelay =
          "0s";
      }, 0);
    } else {
      setActive(true);
      setIsOverflow(!isOverflow);

      // Adding transition delays when adding 'active'
      setTimeout(() => {
        document.querySelector(".all-cases.active").style.transitionDelay =
          "0s";
        document.querySelector(
          ".all-cases.active .layer"
        ).style.transitionDelay = "0.2s";
        document.querySelector(
          ".all-cases.active .inner"
        ).style.transitionDelay = "0.7s";
      }, 0);
    }
  };

  // Search toggle
  const toggleSearch = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const searchQuery = e.target.elements.q.value;
    console.log("Search query:", searchQuery);
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      setLanguage(Number(savedLanguage));
    }
  }, []);
  
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const handleLanguage = (e) => {
    e.preventDefault();
    setLanguage(Number(e.target.value));
  };

  return (
    <>
      {/* <Header section start/> */}
      <div className="preloader">
        <div className="layer"></div>
        <div className="inner">
          <figure>
            <img src={prelorder} alt="Img" />
          </figure>
          <span>The Art of Contact and the Science of Data</span>
        </div>
      </div>

      <div className={`all-cases ${Active ? "active" : ""}`}>
        <div className="layer"> </div>
        <aside className="left-side left-side2">
          <div className="follow-us">FOLLOW US</div>
          <ul>
            <li>
              <Link to="#">
                <i className="fab fa-facebook-f"></i>
              </Link>
            </li>
            <li>
              <Link to="#">
                <i className="fab fa-twitter"></i>
              </Link>
            </li>
            <li>
              <Link to="#">
                <i className="fab fa-linkedin-in"></i>
              </Link>
            </li>
            <li>
              <Link to="#">
                <i className="fab fa-google-plus-g"></i>
              </Link>
            </li>
            <li>
              <Link to="#">
                <i className="fab fa-youtube"></i>
              </Link>
            </li>
          </ul>
          <div className="equalizer">
            <span></span> <span></span> <span></span> <span></span>
          </div>
        </aside>
        <div className="inner">
          <ul>
            <li>
              <NavLink
                to="/news"
                style={({ isActive }) => ({
                  color: isActive ? "#f2cb13" : "transparent",
                  textDecoration: "none",
                  WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                  WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                })}
              >
                {headerTranslations[language]?.news}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/agency"
                style={({ isActive }) => ({
                  color: isActive ? "#f2cb13" : "transparent",
                  textDecoration: "none",
                  WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                  WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                })}
              >
                {headerTranslations[language]?.agency}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/services"
                style={({ isActive }) => ({
                  color: isActive ? "#f2cb13" : "transparent",
                  textDecoration: "none",
                  WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                  WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                })}
              >
                {headerTranslations[language]?.services}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/work"
                style={({ isActive }) => ({
                  color: isActive ? "#f2cb13" : "transparent",
                  textDecoration: "none",
                  WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                  WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                })}
              >
                {headerTranslations[language]?.work}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/team"
                style={({ isActive }) => ({
                  color: isActive ? "#f2cb13" : "transparent",
                  textDecoration: "none",
                  WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                  WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                })}
              >
                {headerTranslations[language]?.team}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                style={({ isActive }) => ({
                  color: isActive ? "#f2cb13" : "transparent",
                  textDecoration: "none",
                  WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                  WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                })}
              >
                {headerTranslations[language]?.contact}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      <main>
        <div>
          <div className="main_header">
            <div
              className="completeMenu"
              style={{
                background: "black",
              }}
            >
              <div className="logo">
                <Link to="/">
                  <img src={Logo} alt="Img" />
                </Link>
              </div>
              <div className="all-cases-link">
                <span className="">
                  <div className="nav-open_main d-flex">
                    <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
                      <NavLink
                        to="/news"
                        className="nav-link"
                        style={({ isActive }) => ({
                          color: isActive ? "#f2cb13" : "white",
                          textDecoration: "none",
                        })}
                        onClick={() => setMenuOpen(false)}
                      >
                        {headerTranslations[language]?.news}
                      </NavLink>
                      <NavLink
                        to="/agency"
                        className="nav-link"
                        style={({ isActive }) => ({
                          color: isActive ? "#f2cb13" : "white",
                          textDecoration: "none",
                        })}
                        onClick={() => setMenuOpen(false)}
                      >
                        {headerTranslations[language]?.agency}
                      </NavLink>
                      <NavLink
                        to="/services"
                        className="nav-link"
                        style={({ isActive }) => ({
                          color: isActive ? "#f2cb13" : "white",
                          textDecoration: "none",
                        })}
                        onClick={() => setMenuOpen(false)}
                      >
                        {headerTranslations[language]?.services}
                      </NavLink>
                      <NavLink
                        to="/work"
                        className="nav-link"
                        style={({ isActive }) => ({
                          color: isActive ? "#f2cb13" : "white",
                          textDecoration: "none",
                        })}
                        onClick={() => setMenuOpen(false)}
                      >
                        {headerTranslations[language]?.work}
                      </NavLink>
                      <NavLink
                        to="/team"
                        className="nav-link"
                        style={({ isActive }) => ({
                          color: isActive ? "#f2cb13" : "white",
                          textDecoration: "none",
                        })}
                        onClick={() => setMenuOpen(false)}
                      >
                        {headerTranslations[language]?.team}
                      </NavLink>
                      <NavLink
                        to="/contact"
                        className="nav-link"
                        style={({ isActive }) => ({
                          color: isActive ? "#f2cb13" : "white",
                          textDecoration: "none",
                        })}
                        onClick={() => setMenuOpen(false)}
                      >
                        {headerTranslations[language]?.contact}
                      </NavLink>
                    </nav>
                    <div className="d-flex nav-open_main1">
                      <div className="language-switching">
                        <select value={language} onChange={handleLanguage}>
                          <option value={1}>ENG</option>
                          <option value={2}>FRE</option>
                          <option value={3}>عربي</option>
                        </select>
                      </div>
                      <div className="searching-toggle mx-0">
                        <div
                          className={`search-toggle ${
                            isSearchOpen ? "opened" : "closed"
                          }`}
                        >
                          <button
                            className="search-icon icon-search"
                            onClick={toggleSearch}
                          >
                            <i className="fa fa-fw fa-search"></i>
                          </button>
                          <button
                            className="search-icon icon-close"
                            onClick={toggleSearch}
                            style={{
                              display: isSearchOpen ? "inline-block" : "none",
                            }}
                          >
                            <i className="fa fa-fw fa-close"></i>
                          </button>
                        </div>

                        <div
                          className={`search-container d-flex ${
                            isSearchOpen ? "opened" : "closed"
                          }`}
                          style={{ display: isSearchOpen ? "block" : "none" }}
                        >
                          <form onSubmit={handleSearch}>
                            <input
                              type="text"
                              name="q"
                              id="search-terms"
                              placeholder="Search terms..."
                              autoFocus={isSearchOpen}
                            />
                            <button
                              type="submit"
                              name="submit"
                              value="Go"
                              className="search-icon"
                            >
                              <i className="fa fa-fw fa-search"></i>
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <b onClick={handleToggleClick}>
                  <i className={`fa ${Active ? "fa-solid" : "fa-bars"}`}></i>
                </b>
              </div>
            </div>
          </div>
          <aside className="left-side">
            <div className="follow-us">FOLLOW US</div>
            <ul>
              <li>
                <Link
                  to="https://www.facebook.com/medialgeria/"
                  target="_blank"
                >
                  <i className="fab fa-facebook-f"></i>
                </Link>
              </li>
              <li>
                <Link to="https://x.com/" target="_blank">
                  <i className="fab fa-twitter"></i>
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFLIm8hcMZygAAAAZG8qETwur3Uzvotg1uL5nQzzNIUTZR-X5fqW-nzhAu8LcBV1Tt4KamACgeaXdCmL3ypUUsKR0tNO1jdyL5JW5y05ftYOC8Mc2XWQdSaAlhRGzFdQTLhbEw=&original_referer=&sessionRedirect=https%3A%2F%2Ffr.linkedin.com%2Fcompany%2Fmedialgeria"
                  target="_blank"
                >
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </li>
              <li>
                <Link to="#" target="_blank">
                  <i className="fab fa-google-plus-g"></i>
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.youtube.com/channel/UCDjQDI9xZ_qh2AW8ohoZRjw"
                  target="_blank"
                >
                  <i className="fab fa-youtube"></i>
                </Link>
              </li>
            </ul>
          </aside>
          <div className={`body-content ${isOverflow ? "overflow" : ""}`}></div>
        </div>

        <header className="slider">
          <div className="swiper-container gallery-top">
            <Swiper
              spaceBetween={0}
              autoplay={{
                delay: 9900,
                disableOnInteraction: false,
              }}
              loop={true}
              loopedSlides={1}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              pagination={{ clickable: true }}
              modules={[Autoplay, Navigation, Pagination]}
              // Add this line
              className="swiper-wrapper"
            >
              <SwiperSlide className="swiper-slide">
                <video src={video1} muted autoPlay loop></video>
              </SwiperSlide>
              <SwiperSlide className="swiper-slide">
                <video src={video2} muted autoPlay loop></video>
              </SwiperSlide>
              <SwiperSlide className="swiper-slide">
                <video src={video3} muted autoPlay loop></video>
              </SwiperSlide>
            </Swiper>
            <div className="swiper-button-prev">
              <GrLinkPrevious />
            </div>
            <div className="swiper-button-next">
              <GrLinkNext />
            </div>
          </div>

          <div className="swiper-container gallery-thumbs">
            <Swiper
              spaceBetween={20}
              slidesPerView={3}
              centeredSlides={true}
              autoplay={{
                delay: 9900,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
              breakpoints={{
                1024: {
                  slidesPerView: 3,
                },
                768: {
                  slidesPerView: 1,
                },
                640: {
                  slidesPerView: 1,
                },
                320: {
                  slidesPerView: 1,
                },
              }}
              className="swiper-wrapper"
            >
              <SwiperSlide className="swiper-slide">
                <span>DISCOVER</span>
              </SwiperSlide>
              <SwiperSlide className="swiper-slide">
                <span>EXCLUSION</span>
              </SwiperSlide>
              <SwiperSlide className="swiper-slide">
                <span>EDITIONAL</span>
              </SwiperSlide>
            </Swiper>
          </div>
        </header>
      </main>

      {/* <Intro  section start/> */}
      <section className="intro">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 wow" data-splitting>
              {introData ? (
                <h3
                  className="section-title"
                  dangerouslySetInnerHTML={{
                    __html: introData.heading_1
                      .replace(/\r\n/g, "<br/>")
                      .replace(/\n/g, "<br/>"),
                  }}
                />
              ) : (
                <h3>
                  HOW WE MAKE <br />
                  USER EXPERIENCES
                </h3>
              )}
              <Link to="#">hello@medialgeria.com</Link>
            </div>
            <div className="col-lg-7 wow" data-splitting>
              {introData ? (
                <p
                  dangerouslySetInnerHTML={{
                    __html: introData.description_1
                      .replace(/\r\n/g, "<br/>")
                      .replace(/\n/g, "<br/>"),
                  }}
                />
              ) : (
                <p>
                  You can't use up creativity. The more you use, the more you
                  have in your signifant mind.
                </p>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* Our Work section start */}
      <section className="intro-image">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="our_workHeading">
                {data ? (
                  <h3 className="heading mb-0">{data.main_heading}</h3>
                ) : (
                  <h3 className="heading mb-0">Loading Api Data....</h3>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div id="cursor"></div>
            <div className="col-12">
              <div className="office-slider">
                <Swiper
                  slidesPerView={3}
                  spaceBetween={20}
                  centeredSlides={false}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  navigation={true}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[Autoplay, Pagination, Navigation]}
                  breakpoints={{
                    1024: {
                      slidesPerView: 3,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    540: {
                      slidesPerView: 2,
                    },
                    320: {
                      slidesPerView: 1,
                    },
                  }}
                  className="swiper-wrapper"
                >
                  <SwiperSlide className="swiper-slide">
                    <figure className="reveal-effect masker wow">
                      {data.image_1 && (
                        <img
                          src={`${baseImg}${data.image_1}`}
                          alt="workImg"
                        />
                      )}
                      <figcaption>
                        {data ? (
                          <h6>{data.image_description_1}</h6>
                        ) : (
                          <h6>Loading APi Data....</h6>
                        )}
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <figure className="reveal-effect masker wow">
                      {data.image_2 && (
                        <img
                          src={`${baseImg}${data.image_2}`}
                          alt="workImg"
                          // alt={OurWork.image_description_1}
                        />
                      )}
                      <figcaption>
                        {data ? (
                          <h6>{data.image_description_2}</h6>
                        ) : (
                          <h6>Loading APi Data....</h6>
                        )}
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <figure className="reveal-effect masker wow">
                      {data.image_3 && (
                        <img src={`${baseImg}${data.image_3}`} alt="workImg" />
                      )}
                      <figcaption>
                        {data ? (
                          <h6>{data.image_description_3}</h6>
                        ) : (
                          <h6>Loading APi Data....</h6>
                        )}
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <figure className="reveal-effect masker wow">
                      {data.image_4 && (
                        <img src={`${baseImg}${data.image_4}`} alt="workImg" />
                      )}
                      <figcaption>
                        {data ? (
                          <h6>{data.image_description_4}</h6>
                        ) : (
                          <h6>Loading APi Data....</h6>
                        )}
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <figure className="reveal-effect masker wow">
                      {data.image_5 && (
                        <img src={`${baseImg}${data.image_5}`} alt="workImg" />
                      )}
                      <figcaption>
                        {data ? (
                          <h6>{data.image_description_5}</h6>
                        ) : (
                          <h6>Loading APi Data....</h6>
                        )}
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <figure className="reveal-effect masker wow">
                      {data.image_6 && (
                        <img src={`${baseImg}${data.image_6}`} alt="workImg" />
                      )}
                      <figcaption>
                        {data ? (
                          <h6>{data.image_description_6}</h6>
                        ) : (
                          <h6>Loading APi Data....</h6>
                        )}
                      </figcaption>
                    </figure>
                  </SwiperSlide>
                </Swiper>
                <div className="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Home Work section start */}
      <section className="team">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 wow" data-splitting>
              {uniqueMedia ? (
                <h3
                  className="section-title"
                  dangerouslySetInnerHTML={{
                    __html: uniqueMedia.heading_2
                      .replace(/\r\n/g, "<br/>")
                      .replace(/\n/g, "<br/>"),
                  }}
                />
              ) : (
                <h3>ABOUT THE OUR NEWS ROOM</h3>
              )}
            </div>
            {/* <!-- end col-8 --> */}
            <div className="col-lg-6 wow" data-splitting>
              {uniqueMedia ? (
                <h5
                  dangerouslySetInnerHTML={{
                    __html: uniqueMedia.description_2
                      .replace(/\r\n/g, "<br/>")
                      .replace(/\n/g, "<br/>"),
                  }}
                />
              ) : (
                <h5>Loading...</h5>
              )}
              <div className="text-right">
                <Link className="showBtn mt-4" to="/news">
                  SHOW ME MORE
                </Link>
              </div>
            </div>
            {/* <!-- end col-4 -->  */}
          </div>
          {/* <!-- end row --> */}

          <div className="row">
            <div className="col">
              <figure className="reveal-effect masker wow">
                {uniqueNews.image_1 && (
                  <img src={`${baseImg}${uniqueNews.image_1}`} alt="workImg" />
                )}
                <div className="workCont">
                  <figcaption className="wow" data-splitting>
                    {uniqueNews ? (
                      <>
                        <h6>{uniqueNews.sub_heading_1}</h6>
                      </>
                    ) : (
                      <p>Lording...</p>
                    )}
                  </figcaption>
                  <Link to="/lg_electronic">read more...</Link>
                </div>
              </figure>
            </div>
            {/* <!-- end col --> */}

            <div className="col">
              <figure className="reveal-effect masker wow">
                {uniqueNews.image_2 && (
                  <img src={`${baseImg}${uniqueNews.image_2}`} alt="workImg" />
                )}
                <div className="workCont">
                  <figcaption className="wow" data-splitting>
                    {uniqueNews ? (
                      <>
                        <h6>{uniqueNews.sub_heading_2}</h6>
                      </>
                    ) : (
                      <p>Lording...</p>
                    )}
                  </figcaption>
                  <Link to="/emirate_trip">read more...</Link>
                </div>
              </figure>
            </div>
            {/* <!-- end col --> */}

            <div className="col">
              <figure className="reveal-effect masker wow">
                {uniqueNews.image_3 && (
                  <img src={`${baseImg}${uniqueNews.image_3}`} alt="workImg" />
                )}
                <div className="workCont">
                  <figcaption className="wow" data-splitting>
                    {uniqueNews ? (
                      <>
                        <h6>{uniqueNews.sub_heading_3}</h6>
                      </>
                    ) : (
                      <p>Loading...</p>
                    )}
                  </figcaption>
                  <Link to="/cock_studio">read more...</Link>
                </div>
              </figure>
            </div>
            {/* <!-- end col --> */}

            <div className="col">
              <figure className="reveal-effect masker wow">
                {uniqueNews.image_4 && (
                  <img src={`${baseImg}${uniqueNews.image_4}`} alt="workImg" />
                )}
                <div className="workCont">
                  <figcaption className="wow" data-splitting>
                    {uniqueNews ? (
                      <>
                        <h6>{uniqueNews.sub_heading_4}</h6>
                      </>
                    ) : (
                      <p>Loading...</p>
                    )}
                  </figcaption>
                  <Link to="/news_huawei">read more...</Link>
                </div>
              </figure>
            </div>
          </div>
        </div>
      </section>
      {/* Home Team section start */}
      <section className="join_wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 join_content">
              {joinUsData ? (
                <>
                  <h2
                    dangerouslySetInnerHTML={{
                      __html: joinUsData.heading_3
                        .replace(/\r\n/g, "<br/>")
                        .replace(/\n/g, "<br/>"),
                    }}
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: joinUsData.description_3
                        .replace(/\r\n/g, "<br/>")
                        .replace(/\n/g, "<br/>"),
                    }}
                  />
                </>
              ) : (
                <p>
                  Join a leading communications group and work on exciting and
                  impactful projects.
                </p>
              )}
              <Link className="joinBtn" to="/join_inner">
                Join Us
              </Link>
            </div>
          </div>
        </div>
      </section>
       {/* Home Partners section start */}
      <section className="clients">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-sm-12 wow" data-splitting>
              <h3 className="section-title">
                {headerTranslations[language]?.partnerstext}
              </h3>
            </div>
            <div className="col-lg-7">
              <ul>
                <li className="reveal-effect masker wow">
                  <img src={image1} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={image2} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={image3} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={img4} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={img5} alt="Img" />
                </li>
                <li className="reveal-effect masker wow">
                  <img src={img6} alt="Img" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <div className="logoFooter_content">
                <div className="footer_logo">
                  <img src={Logo} alt="footer logo" />
                </div>
                <div className="footer_content">
                  {footerData ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: footerData.description
                          .replace(/\r\n/g, "<br/>")
                          .replace(/\n/g, "<br/>"),
                      }}
                    />
                  ) : (
                    <p>Loading Api Data...</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="navigation-footer">
                <h4>{headerTranslations[language]?.ourservices}</h4>
                <ul>
                  <li>
                    <Link to="/news">{headerTranslations[language]?.news}</Link>
                  </li>
                  <li>
                    <Link to="/agency">
                      {headerTranslations[language]?.agency}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service">
                      {headerTranslations[language]?.services}
                    </Link>
                  </li>
                  <li>
                    <Link to="/work">{headerTranslations[language]?.work}</Link>
                  </li>
                  <li>
                    <Link to="/team">{headerTranslations[language]?.team}</Link>
                  </li>
                  <li>
                    <Link to="/contact"></Link>
                    {headerTranslations[language]?.contact}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footerContact_info">
                <h4>{headerTranslations[language]?.contact}</h4>
              </div>
              <div className="footerContact_data">
                <ul>
                  <li>{headerTranslations[language]?.contact}:- +9645689866</li>
                  <li>
                    {headerTranslations[language]?.email}:- info@medialgeria.com
                  </li>
                  <li>
                    {headerTranslations[language]?.address}:- 16122 Collins
                    Street, Melbourne, Australia
                  </li>
                </ul>
              </div>
              {/* <Link to="/contact" className="link">
                Get in touch
              </Link> */}
              <ul className="my-4 social">
                <li>
                  <Link
                    to="https://www.facebook.com/medialgeria/"
                    target="_blank"
                  >
                    <FaFacebookF />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaTwitter />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFLIm8hcMZygAAAAZG8qETwur3Uzvotg1uL5nQzzNIUTZR-X5fqW-nzhAu8LcBV1Tt4KamACgeaXdCmL3ypUUsKR0tNO1jdyL5JW5y05ftYOC8Mc2XWQdSaAlhRGzFdQTLhbEw=&original_referer=&sessionRedirect=https%3A%2F%2Ffr.linkedin.com%2Fcompany%2Fmedialgeria"
                    target="_blank"
                  >
                    <FaLinkedinIn />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaGooglePlusG />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.youtube.com/channel/UCDjQDI9xZ_qh2AW8ohoZRjw"
                    target="_blank"
                  >
                    <FaYoutube />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-12">
              <div className="footer-bar">
                <span className="copyright">
                  © 2024 Medialgeria | All Rights Reserved
                </span>
                <span className="creation">
                  Site created by
                  <Link to="https://www.webnmobappssolutions.com/">
                    webnmobapps solutions Pvt. Ltd
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Home;